import React, { createContext, useContext, useState, useCallback } from 'react';

const WebSocketContext = createContext(null);

export const useWebSocket = () => {
  return useContext(WebSocketContext);
};

// WebSocket is disabled - the Kubernetes ingress does not support persistent 
// WebSocket connections, causing rapid connect/disconnect cycles that overload
// the server when multiple users are connected simultaneously.
// When proper WebSocket support is available, re-enable auto-connect.
export const WebSocketProvider = ({ children }) => {
  const [isConnected] = useState(false);
  const [lastMessage] = useState(null);

  const sendMessage = useCallback(() => {
    // No-op: WebSocket disabled
  }, []);

  const connect = useCallback(() => {
    // No-op: WebSocket disabled
  }, []);

  const disconnect = useCallback(() => {
    // No-op: WebSocket disabled
  }, []);

  const value = {
    isConnected,
    lastMessage,
    sendMessage,
    connect,
    disconnect
  };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
};
